import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { makeStyles, Typography, Box } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "../../components/layout/TopBar";
import { connect } from "react-redux";
import { apiEndpoints, apiGetRequest, apiPostRequest } from "src/utils/api/api";
import actions from "src/duck/global/actions";
// import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import "moment/locale/pl";
import { userHasAtLeastOnePermission } from "src/utils/userutils";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: "flex",
    height: "100%",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 64,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: theme.dimensionscustom.menuWidth,
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
  },
  wrapperNoLog: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  ueLogo: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "45%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "55%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const DashboardLayout = ({
  globalData,
  setAuthorized,
  setCurrentUserData,
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  incrementSessionTime,
  setInactivityLogout,
  setSystemInfo,
  unsetCurrentUser,
  setCalendarEventsCount,
  setRedirectPath,
  unsetRedirectPath,
  setVotingNoVoteCount,
  ...rest
}) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const navigate = useNavigate();
  // const [cookies, removeCookie] = useCookies(["JwtToken"]);
  const [locale] = useState("pl");

  const sourcePath = window.location.pathname;

  useEffect(() => {
    if (globalData.currentUser.logout) {
      // removeCookie("JwtToken");
      enableGlobalLoader();
      apiPostRequest(apiEndpoints.logout.path, {"username":globalData.currentUser.currentUserData.username}, true)
        .then((data) => {
          unsetCurrentUser();
          disableGlobalLoader();
          navigate("/logowanie");
        })
        .catch((error) => {});
    } else {
      apiGetRequest(apiEndpoints.getSystemInfo.path, true)
        .then((data) => {
          setSystemInfo(data);
        })
        .catch((error) => {});
      apiGetRequest(apiEndpoints.getCalendarInfo.path, true)
        .then((data) => {
          setCalendarEventsCount(data.count);
        })
        .catch((error) => {});
    }
  }, [globalData.currentUser.logout]);

  useEffect(() => {
    unsetRedirectPath();
    // if (cookies.JwtToken) {
    if (!globalData.currentUser.isAuthorized) {
      getUserData();
    } else {
      if (userHasAtLeastOnePermission(globalData, ["voting", "super_admin"])) {
        apiGetRequest(apiEndpoints.getVotingInfo.path, true)
          .then((data) => {
            setVotingNoVoteCount(data.count);
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              setLogoutUser(true);
            }
          });
      } else {
        setVotingNoVoteCount(null);
      }
    }
    // } else {
    //   setRedirectPath(sourcePath);
    //   navigate("/logowanie");
    // }
    return () => {};
  }, [globalData.currentUser]);

  const getUserData = () => {
    return apiGetRequest(apiEndpoints.getLoggedUser.path, true)
      .then((data) => {
        setAuthorized(true);
        setCurrentUserData(data);
        incrementSessionTime();
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setRedirectPath(sourcePath);
          // removeCookie("JwtToken");
          navigate("/logowanie");
        } else if (error.response && error.response.status === 403) {
          if (error.response.data) {
            if (error.response.data.code === "LICENCE_NOT_ACCEPTED") {
              navigate("/licencja");
            } else if (error.response.data.code === "POLICY_NOT_ACCEPTED") {
              navigate("/politykabezp");
            } else if (
              error.response.data.code === "MEMBER_TASKS_NOT_ACCEPTED"
            ) {
              navigate("/deklaracjazadaniacz");
            } else if (
              error.response.data.code === "OBSERVER_TASKS_NOT_ACCEPTED"
            ) {
              navigate("/deklaracjazadaniaobs");
            }
          }
        } else {
          // removeCookie("JwtToken");
          navigate("/logowanie");
        }
      });
  };

  const handleSessionTimeFinished = () => {
    setInactivityLogout(true);
    // removeCookie("JwtToken");

    apiPostRequest(apiEndpoints.logout.path, {"username":globalData.currentUser.currentUserData.username}, true)
      .then((data) => {
        unsetCurrentUser();
        disableGlobalLoader();
        navigate("/logowanie");
      })
      .catch((error) => {});
  };
  const handleRefreshSessionTime = () => {
    getUserData();
  };

  return !globalData.currentUser.isAuthorized /*&& !cookies.JwtToken*/ ? (
    <div className={classes.root}>{/* <Navigate to="/logowanie" /> */}</div>
  ) : (
    <MuiPickersUtilsProvider
      libInstance={moment}
      utils={MomentUtils}
      locale={locale}
    >
      <div className={classes.root}>
        <TopBar
          onMobileNavOpen={() => setMobileNavOpen(true)}
          setLogoutUser={() => setLogoutUser(true)}
          isAuthorized={globalData.currentUser.isAuthorized}
          loaderOn={globalData.globalLoader}
          systemInfo={globalData ? globalData.systemInfo : null}
        />
        <NavBar
          enableGlobalLoader={enableGlobalLoader}
          disableGlobalLoader={disableGlobalLoader}
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
          user={globalData.currentUser.currentUserData}
          onSessionTimeFinished={handleSessionTimeFinished}
          onSessionTimeRefresh={handleRefreshSessionTime}
          setLogoutUser={() => setLogoutUser(true)}
          isAuthorized={globalData.currentUser.isAuthorized}
          calendarEventsCount={globalData.calendarEventsCount}
          votingsNoVoteCount={globalData.votingsNoVoteCount}
          version={globalData ? globalData.systemInfo.systemVersion : null}
        />
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content} tabIndex="-1">
              <Outlet />
              <Box display="flex" flexDirection="column" pt={2} pb={2}>
                <img
                  className={classes.img}
                  alt="Logo UE stopka"
                  src="/static/images/logo_ue_main.jpg"
                />
                <Typography
                  variant="caption"
                  gutterBottom
                  color="textSecondary"
                  align="center"
                  component="p"
                >
                  Aplikacja współfinansowana przez Unię Europejską ze środków
                  Europejskiego Funduszu Społecznego w ramach Regionalnego
                  Programu Operacyjnego Województwa Podlaskiego na lata
                  2014-2020
                </Typography>
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                  align="center"
                  component="p"
                >
                  2021 © Urząd Marszałkowski Województwa Podlaskiego
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setCurrentUserData: (currentUserData) =>
    dispatch(actions.setCurrentUser(currentUserData)),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  incrementSessionTime: () => dispatch(actions.incrementSessionTime()),
  setInactivityLogout: (inactivityLogout) =>
    dispatch(actions.setInactivityLogout(inactivityLogout)),
  setSystemInfo: (systemInfo) => dispatch(actions.setSystemInfo(systemInfo)),
  unsetCurrentUser: () => dispatch(actions.unsetCurrentUser()),
  setCalendarEventsCount: (calendarEventsCount) =>
    dispatch(actions.setCalendarEventsCount(calendarEventsCount)),
  setRedirectPath: (redirectPath) =>
    dispatch(actions.setRedirectPath(redirectPath)),
  unsetRedirectPath: () => dispatch(actions.unsetRedirectPath()),
  setVotingNoVoteCount: (votingsNoVoteCount) =>
    dispatch(actions.setVotingNoVoteCount(votingsNoVoteCount)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLayout);
